export const baseStationStates = {
    active: "active",
    notActive: "notActive",
    authorized: "authorized",
    idle: "assumedIdle",
    new: "new"
}

export const georefStateMap = {
    GEOREFERENCED:         { label: 'GEOREFERENCED',   color: '#4caf50' },
    NOT_YET_GEOREFERENCED: { label: 'NOT YET GEOREF.', color: '#ff9800' },
    NEW_ANTENNA:           { label: 'NEW ANTENNA',     color: '#1565c0' },
    UNEXPECTED:            { label: 'UNEXPECTED',      color: '#f44336' },
    GEOREFERENCING:        { label: 'GEOREFERENCING',  color: '#7b1fa2' },
}

export const firmwareStateMap = {
    SETTLED:              { label: 'settled',              class: 'grey-light3--bg'   },
    OUTDATED:             { label: 'outdated',             class: 'amber-light3--bg'  },
    TEST_DEVICE:          { label: 'test device',          class: 'purple-light3--bg' },
    UNKNOWN:              { label: 'unknown',              class: 'orange-light3--bg' },
    NOT_FOUND:            { label: 'not found',            class: 'red-light5--bg'    },
    ERROR:                { label: 'error',                class: 'red-light5--bg'    },
    AUTO_UPDATE_DISABLED: { label: 'auto-update disabled', class: 'grey-light2--bg'   },
}

export const georefTaskActiveStatuses = ['PREPARING', 'WAITING', 'IN_PROGRESS']